'use client';
var _classes = {"code":"m_5caae6d3","pre":"m_2c47c4fd","header":"m_e58679f3","controls":"m_be7e9c9c","copy":"m_5caae85b","control":"m_d498bab7","file":"m_5cac2e62","files":"m_38d99e51","codeWrapper":"m_9f507240","showCodeButton":"m_c9378bc2","root":"m_5cb1b9c8","fileIcon":"m_b46cddfb"};

export { _classes as default };
//# sourceMappingURL=CodeHighlight.module.css.mjs.map
